import gql from 'graphql-tag';

export default gql`
  fragment blastengineAutomaticMailSendMailOpenProspectActivityFragment on BlastengineAutomaticMailSendMailOpenProspectActivity {
    id
    automaticMailSend {
      step {
        name
      }
    }
    createdAt
  }
`;
